import { render } from "./protected.vue?vue&type=template&id=38b4ef84"
import script from "./protected.vue?vue&type=script&lang=js"
export * from "./protected.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__